import { z } from 'zod';
import { PartnerNewsImageFormatSchema } from '../../entities/partner-news/partner-news.schema';
/**
 * Request Partner News Image Upload
 * POST /api/v2/admin/partner-news/:id/images/:slot/upload-url
 *
 * The presigned POST pins the content type, so the format is chosen up front.
 */ export const RequestPartnerNewsImageUploadRequestSchema = z.object({
    format: PartnerNewsImageFormatSchema
});
export const RequestPartnerNewsImageUploadResponseSchema = z.object({
    url: z.string(),
    fields: z.record(z.string(), z.string()),
    key: z.string()
});

//# sourceMappingURL=request-partner-news-image-upload.schema.js.map